import {DrawingInfo} from "./DrawingInfo/DrawingInfo";
import {SectionLabel} from "../../common/SectionLabel";
import styles from "./DrawingsInfo.module.css";


export const DrawingsInfo = ({drawInfo, onDrawingEditDelete, cropsOptions, settlementCompanies = []}) => {
    // М2: колко реда са сверени — числото стои до надписа, за да се вижда
    // докъде е стигнала проверката, без да се броят редове на ръка.
    const total = drawInfo.length;
    const verified = drawInfo.filter(d => d.verified).length;

    return (
        <>
            <SectionLabel width="75%">
                Изчертани площи
                {total > 0 && (
                    <span style={{
                        textTransform: "none",
                        fontWeight: 400,
                        color: "var(--app-muted)",
                        letterSpacing: "normal",
                    }}> · проверени {verified} от {total}</span>
                )}
            </SectionLabel>
            {/* Щ4: ширината вече е в CSS модула — таблицата расте, преди
                забележката да се пренесе, но спира пред фиксираните карти. */}
            <div className={styles.wrap}>
                <table className={`table ${styles.table}`}>
                    <thead>
                    <tr>
                        <th className={`text-center ${styles.colDate}`} scope="col">Дата</th>
                        <th className="text-center" scope="col">Масив</th>
                        <th className="text-center" scope="col">МПО номер</th>
                        <th className="text-center" scope="col">Площ</th>
                        <th className="text-center" scope="col">Култура</th>
                        {/* Ш3: забележката е СЛЕД културата — така е поискана и
                            така върви във всички справки. */}
                        <th className={styles.colNote} scope="col">Забележка</th>
                        <th scope="col"></th>
                        <th scope="col"></th>
                        {/* Ш2: колоната на бутона „Забележка" */}
                        <th scope="col"></th>
                        {/* М2: колоната на отметката „Проверено" */}
                        <th scope="col"></th>
                    </tr>
                    </thead>
                    <tbody>
                    {drawInfo.map(drawing => (
                        <DrawingInfo key={drawing.id} {...drawing} onDrawingEditDelete={onDrawingEditDelete}
                                     cropsOptions={cropsOptions}
                                     settlementCompanies={settlementCompanies}/>))}
                    </tbody>
                </table>
            </div>
        </>
    );
};
